<template>
<!-- Sidebar -->
<div id="sidebar-wrapper" ref="sidebar">
    <ul class="sidebar-nav nav-pills nav-stacked" id="menu">
        <li id="dashboard" ref="dashboard">
            <router-link v-bind:to="{name: 'Dashboard'}" class="menu-icon dashboard-icon">
                <!-- <span class="fa-stack fa-lg pull-left">
                    <i class="fa fa-tachometer fa-stack-1x"></i>
                </span> -->
                Dashboard
            </router-link>
        </li>
    </ul>
</div>
<!-- Sidebar -->
</template>

<script>
import Vue from 'vue';
import EventBus from '.././event-bus';
import {
    commonMixins
} from '../../mixins/commonMixins';
var self;

export default {
    name: 'Sidebar',
    mixins: [commonMixins],
    components: {},
    data() {
        return {
            userRole : null,
            menuArray: [{
                    name: "Users",
                    isActive: false,
                    ref: "listuser",
                    id: "listuser",
                    routerlink: {
                        name: "ListUser"
                    },
                    icon: "fa fa-users fa-stack-1x"
                },

            ]
        }
    },
    beforeMount: function () {
        self = this;
    },
    mounted: function () {
      var userObj = localStorage.getItem("user_obj");
      var userJson = JSON.parse(userObj);

      if(userJson != null) {
        if(userJson['roles'].length > 0) {
          userJson['roles'].forEach(element => {
              if(element.name == 'Admin') {
                self.userRole = element.name;
              } else if(element.name == 'Manager') {
                self.userRole = element.name;
              } else if(element.name == 'User') {
                self.userRole = element.name;
              } else {
                self.userRole = 'guest';
              }
          });

        }
      }


        $("#menu-toggle").click(function (e) {
            e.preventDefault();
            $(".app-sidebar-right").toggleClass("toggled");
        });
        $("#menu-toggle-2").click(function (e) {
            e.preventDefault();
            $(".app-sidebar-right").toggleClass("toggled-2");
            $("#menu ul").hide();
        });

        $(".tree-toggle").click(function () {
            $(this).parent().children("ul.tree").toggle(200);
        });
    },
    methods: {
        getActiveMenu: function () {
        },
        initMenu: function () {
            $('#menu ul').hide();
            $('#menu ul').children('.current').parent().show();
            //$('#menu ul:first').show();
            $('#menu li a').click(
                function () {
                    var checkElement = $(this).next();
                    if ((checkElement.is('ul')) && (checkElement.is(':visible'))) {
                        return false;
                    }
                    if ((checkElement.is('ul')) && (!checkElement.is(':visible'))) {
                        $('#menu ul:visible').slideUp('normal');
                        checkElement.slideDown('normal');
                        return false;
                    }
                }
            );
        },
    }
}
EventBus.$on("menu-selection-changed", function (menuref) {
    if (typeof self != "undefined") {
        $("#menu").children().removeClass('active');
        $("#" + menuref).addClass('active');
        /* for (var i = 0; i < self.menuArray.length; i++) {
            var menuObject = self.menuArray[i];
            if (menuref == menuObject.ref) {
                menuObject.isActive = true;
            } else {
                menuObject.isActive = false;
            }
        } */
    }
});
</script>



// WEBPACK FOOTER //
// src/components/partials/Sidebar.vue